import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-area" }
const _hoisted_2 = {
  id: "user-area--content",
  class: "user-area--content"
}

import UserAreaHeader from '@/components/userArea/UserAreaHeader.vue';
import UserAreaNavigationSidebar from '@/components/userArea/UserAreaNavigationSidebar.vue';
import UserAreaFooter from '@/components/userArea/UserAreaFooter.vue';
import { computed, ComputedRef, onBeforeMount, onMounted, watch } from 'vue';
import { useUserStore } from '@/stores/user.store';
import { useAppStore } from '@/stores/app.store';
import { useNavigationStore } from '@/stores/navigation.store';
import { useCookies } from '@vueuse/integrations/useCookies';
import LangWrapper from '@/components/common/layoutWrappers/LangWrapper.vue';
import useLocalization from '@/composables/useLocalization';
import BottomMobileMenu from '@/components/common/bottomMobileMenu/BottomMobileMenu.vue';
import { IMobileMenuItem } from '@/types/mobileMenuTypes';
import { CwxBackend } from '@/types/cwxBackend';
import useTranslations from '@/composables/useTranslations';
import { INavigationSidebarItem } from '@/types/navigationSidebarTypes';
import { useSpaceStore } from '@/stores/space.store';
import AccessibilityMenu from '@/components/common/accesibility/AccessibilityMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAreaLayout',
  setup(__props) {

const userStore = useUserStore();
const appStore = useAppStore();
const spaceSore = useSpaceStore();
const navigationStore = useNavigationStore();
const cookies = useCookies(['localhost']);
const { initApplicationLanguage } = useLocalization();
const { translate: t } = useTranslations();

const bottomMobileMenuItems: ComputedRef<IMobileMenuItem[]> = computed(() => {
  return prepareBottomMobileMenuItems(navigationStore.sidebarNavigationMenu, 0);
});

function prepareBottomMobileMenuItems(
  navigationItems: INavigationSidebarItem[],
  menuLevel: number,
) {
  const newMenuItems: IMobileMenuItem[] = navigationItems?.map((item, index) => {
    return {
      id: item?.id,
      title:
        item?.icon == 'icon-cog'
          ? t('Common.AdminArea')
          : item?.type === CwxBackend.SpaceSidebarType.Separator
            ? ''
            : item?.text,
      iconClass:
        menuLevel == 0
          ? ` navigation-sidebar-item__menu--icon cwx-old-icon ${item.icon} cwx-icon cwx-icon-before_${item.icon}`
          : `icon-large icon-circle submenu-color-${index}`,
      url: item?.url,
      selected:
        item?.selected &&
        !(item?.type == CwxBackend.SpaceSidebarType.Separator) &&
        !(item?.subItems?.length > 0),
      separator: item?.type == CwxBackend.SpaceSidebarType.Separator ? true : undefined,
      items: item?.subItems ? prepareBottomMobileMenuItems(item.subItems, 1) : undefined,
    } as IMobileMenuItem;
  });

  return newMenuItems;
}

onBeforeMount(async () => {
  await appStore.fetchCultureSettings();
  await appStore.fetchCustomCssSettings();
  initApplicationLanguage();
  await Promise.all([navigationStore.fetchTopMenuNavigation(), appStore.fetchSystemSettings()]);
});

onMounted(async () => {
  document.body.classList.add('user-area-layout');
  await userStore.fetchUserSettings();
});

watch(
  () => userStore.userSettings.cultureCode,
  () => {
    const cultureCookie = cookies.get('culture');
    if (
      cultureCookie === undefined &&
      userStore?.userSettings?.cultureCode &&
      userStore?.userSettings?.cultureCode?.length > 1
    )
      appStore.cultureCode = userStore?.userSettings?.cultureCode;
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(appStore)?.cultureCode?.length > 1)
    ? (_openBlock(), _createBlock(LangWrapper, {
        key: 0,
        language: _unref(appStore).getLanguage(),
        locale: _unref(appStore).getLocale()
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AccessibilityMenu),
            _createVNode(UserAreaHeader),
            _createVNode(UserAreaNavigationSidebar, { class: "user-area--body" }, {
              default: _withCtx(() => [
                _createElementVNode("main", _hoisted_2, [
                  _createVNode(_component_router_view)
                ]),
                _createVNode(UserAreaFooter)
              ]),
              _: 1
            }),
            (_unref(appStore)?.isMobile)
              ? (_openBlock(), _createBlock(BottomMobileMenu, {
                  key: 0,
                  "menu-items": bottomMobileMenuItems.value,
                  title: _unref(spaceSore)?.spaceDetails?.name
                }, null, 8, ["menu-items", "title"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["language", "locale"]))
    : _createCommentVNode("", true)
}
}

})